import { render, staticRenderFns } from "./CompanyEmployees.vue?vue&type=template&id=32676cc2&scoped=true"
import script from "./CompanyEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyEmployees.vue?vue&type=script&lang=js"
import style0 from "./CompanyEmployees.vue?vue&type=style&index=0&id=32676cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32676cc2",
  null
  
)

export default component.exports